<div class="event-hosts">
  @if (event && font) {
    <div class="multiple-attendees">
      <div class="attendees" [class.event-card-attendees]="eventCardView">
        @for (attendee of limitedAttendees; track attendee.id) {
          <div class="event-attendee">
            <app-user-avatar
              [user]="attendee.user"
              [size]="avatarSize"
              [nameTooltip]="true"
              [style.height.px]="avatarSize"
              [placeholderFontSize]="avatarPlaceholderFontSize"
              [fallbackInitials]="attendee.getFallbackInitials()"
            ></app-user-avatar>
          </div>
        }
      </div>
    </div>
  }
</div>
